import {
  Modal,
  Button,
  Row,
  Col,
  Form,
  InputGroup
} from "react-bootstrap";
import { X } from "lucide-react";
import { useContext, useEffect, useRef, useState } from "react";
import { getAccountUserProfile, UpdateAccountUser } from "../../../services/adminApiService/accountManagementApi/AccountManagementApiService";
import { useParams } from "react-router-dom";
import { validateAccountEdit } from "./AccountEditValidation";
import { AccountManagementContext } from "../../../context/AccountManagementContext";
import Swal from "sweetalert2";
import swal from "sweetalert";
import notify from "../../../utils/notification";
import { formToJSON } from "axios";
export default function AccountEditManagement({ show, onHide }) {
  const [accountProfileData, setAccountProfileData] = useState();
  const {
    statesList,
    districtList,
    fetchDistricts,
    fetchStates,
    fetchVerificationList,
  } = useContext(AccountManagementContext);


  const [formData, setFormData] = useState({
    user_name: "",
    father_name: "",
    gender: "",
    email: "",
    mobile: "",
    dob: "",
    street: "",
    landmark: "",
    district: "",
    state: "",
    country: "",
    zip: "",
    photo: "",
  });
 


  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const fileInputRef = useRef(null);
  // console.log("errors========>",errors)
  const { id } = useParams();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setErrors((prev) => ({ ...prev, photo: "Photo is required" }));
      return;
    }

    // Optional: validate file type
    if (!file.type.startsWith("image/")) {
      setErrors((prev) => ({ ...prev, photo: "Only image files are allowed" }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      photo: file,
    }));

    setErrors((prev) => ({ ...prev, photo: "" }));
  };


  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const validationErrors = validateAccountEdit(formData);

    // ❌ Stop submission if errors exist
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setLoading(true);
      setErrors({}); // clear errors

      // ✅ Use FormData for image upload
      const payload = new FormData();

      // Object.keys(formData).forEach((key) => {
      //   payload.append(key, formData[key]);
      // });

      Object.keys(formData).forEach((key) => {
        if (key === "photo") {
          if (formData.photo instanceof File) {
            payload.append("photo", formData.photo);
          }
        } else {
          payload.append(key, formData[key] || "");
        }
      });

      for (let pair of payload.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await UpdateAccountUser(id, payload);

      if (response?.data?.status === true) {

        swal("Success", response?.data?.message || "success");

        await fetchVerificationList(id);
        onHide();
      }
      handleBackendErrors(response?.data);
    } catch (error) {
      handleBackendErrors(error.response?.data);

    } finally {
      setLoading(false);
    }
  };


  const handleBackendErrors = (data) => {
    if (!data) return;

    // ✅ If backend sends field errors as object
    if (typeof data.message === "object" && data.message !== null) {
      const formattedErrors = {};

      Object.keys(data.message).forEach((field) => {
        const fieldName = field === "image_url" ? "photo" : field;

        formattedErrors[fieldName] = Array.isArray(data.message[field])
          ? data.message[field][0]
          : data.message[field];
      });

      setErrors(formattedErrors);
    }

    // ✅ If backend sends string error
    // else if (typeof data.message === "string") {
    //   notify("error", data.message);
    // }

    // ✅ If backend sends `errors` key instead
    else if (data.errors) {
      const formattedErrors = {};

      Object.keys(data.errors).forEach((field) => {
        const fieldName = field === "image_url" ? "photo" : field;

        formattedErrors[fieldName] = Array.isArray(data.errors[field])
          ? data.errors[field][0]
          : data.errors[field];
      });

      setErrors(formattedErrors);
    }

    else {
      console.log("Something went wrong.")
      // notify("error", "Something went wrong.");
    }
  };

  useEffect(() => {
    const fetchVerificationList = async () => {
      try {
        const response = await getAccountUserProfile(id);
        const data = response?.data?.data;
        setAccountProfileData(data);


        // ✅ Auto-fill form inputs
        setFormData({
          user_name: data?.name || "",
          father_name: data?.father_name || "",
          gender: data?.gender || "",
          email: data?.email || "",
          mobile: data?.phone || "",
          dob: data?.dob || "",
          street: data?.street || "",
          landmark: data?.landmark || "",
          district: data?.district_id || "",
          state: data?.state_id || "",
          country: data?.country || "India",
          zip: data?.zip || "",
          photo: data?.image_url, // ❗ keep null (file cannot be auto-filled)
        });
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };




    if (show && id) {
      fetchVerificationList();
    }
  }, [show, id]);

  const handleReset = () => {
    if (!accountProfileData) return;

    setFormData({
      user_name: accountProfileData?.user_name || "",
      father_name: "",
      gender: "",
      email: "",
      mobile: accountProfileData?.mobile || "",
      dob: "",
      street: accountProfileData?.street || "",
      landmark: accountProfileData?.landmark || "",
      district: accountProfileData?.district_name || "",
      state: accountProfileData?.state || "",
      country: "",
      zip: accountProfileData?.zip || "",
      photo: null,
      // reset file
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // clears file input
    }


    setErrors({});
  };


  useEffect(() => {
    if (!show) {
      setErrors({});
    }
  }, [show]);

  useEffect(() => {
    fetchDistricts(formData.state);
  }, [formData.state, fetchDistricts]);

  useEffect(() => {
    fetchStates();
  }, [fetchStates]);


  return (
    <Modal show={show} onHide={onHide} size="xl" centered backdrop="static">
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="fw-semibold">Edit Details</Modal.Title>
        <Button variant="light" className="p-1 bg-transparent border-0 shadow-none" onClick={onHide}>
          <X size={18} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <h6 className="section-title mb-3">Personal Details</h6>

        <Row className="g-3 mb-4">
          <Col md={4}>
            <Form.Label>
              Full Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="user_name"
              value={formData.user_name}
              onChange={handleChange}
              isInvalid={!!errors.user_name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.user_name}
            </Form.Control.Feedback>
          </Col>

          <Col md={4}>
            <Form.Label>Father&apos;s Name</Form.Label>
            <Form.Control
              name="father_name"
              value={formData.father_name}
              onChange={handleChange}
              isInvalid={!!errors.father_name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.father_name}
            </Form.Control.Feedback>
          </Col>

          <Col md={4}>
            <Form.Label>
              Gender
            </Form.Label>
            <Form.Select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              isInvalid={!!errors.gender}
              style={{
                padding: "10px 14px",
                backgroundColor: "transparent",
                boxShadow: "none"
              }}
            >
              <option value="">Select</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.gender}
            </Form.Control.Feedback>
          </Col>

          <Col md={4}>
            <Form.Label>
              Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="email"
              value={formData.email}
              onChange={handleChange}
              isInvalid={!!errors.email}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Col>

          <Col md={4}>
            <Form.Label>
              Mobile Number <span className="text-danger">*</span>
            </Form.Label>
            <InputGroup>
              {/* <InputGroup.Text>🇮🇳</InputGroup.Text> */}
              <Form.Control
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                isInvalid={!!errors.mobile}
              />
            </InputGroup>
            <Form.Control.Feedback type="invalid" className="d-block">
              {errors.mobile}
            </Form.Control.Feedback>
          </Col>

          <Col md={4}>
            <Form.Label>
              Date of Birth
            </Form.Label>
            <Form.Control
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              isInvalid={!!errors.dob}
            />
            <Form.Control.Feedback type="invalid">
              {errors.dob}
            </Form.Control.Feedback>
          </Col>
          {/* <Col md={4}>
            <Form.Label>
              Upload Photo
            </Form.Label>
            <Form.Control
              type="file"
              name="photo"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleFileChange}
              isInvalid={!!errors.photo}

            />
            <Form.Control.Feedback type="invalid">
              {errors.photo}
            </Form.Control.Feedback>
          </Col> */}

        </Row>

        <h6 className="section-title mb-3">Address</h6>

        <Row className="g-3">
          <Col md={4}>
            <Form.Label>
              Country <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="country"
              value={formData.country}
              onChange={handleChange}
              isInvalid={!!errors.country}
            />
            <Form.Control.Feedback type="invalid">
              {errors.country}
            </Form.Control.Feedback>
          </Col>
          <Col md={4}>
            <Form.Label>
              State <span className="text-danger">*</span>
            </Form.Label>
            <select
              name="state"
              className={`form-control ${errors.state ? "is-invalid" : ""}`}
              value={formData.state}
              onChange={handleChange}
            >
              <option value="">Select State</option>
              {statesList.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.name}
                </option>
              ))}
            </select>
            <Form.Control.Feedback type="invalid">
              {errors.state}
            </Form.Control.Feedback>
          </Col>
          <Col md={4}>
            <Form.Label>
              City <span className="text-danger">*</span>
            </Form.Label>
            <select
              name="district"
              className={`form-control ${errors.district ? "is-invalid" : ""}`}
              value={formData.district}
              onChange={handleChange}
              disabled={!formData.state}
            >
              <option value="">Select District</option>
              {districtList.map((district) => (
                <option key={district.id} value={district.id}>
                  {district.name}
                </option>
              ))}
            </select>
            <Form.Control.Feedback type="invalid">
              {errors.city}
            </Form.Control.Feedback>
          </Col>
          {/* <Col md={4}>
            <Form.Label>
              Street
            </Form.Label>
            <Form.Control
              name="street"
              value={formData.street}
              onChange={handleChange}
              isInvalid={!!errors.street}
            />
            <Form.Control.Feedback type="invalid">
              {errors.street}
            </Form.Control.Feedback>
          </Col> */}

          {/* <Col md={4}>
            <Form.Label>Landmark</Form.Label>
            <Form.Control
              name="landmark"
              value={formData.landmark}
              onChange={handleChange}
              isInvalid={!!errors.landmark}
            />
            <Form.Control.Feedback type="invalid">
              {errors.landmark}
            </Form.Control.Feedback>
          </Col> */}
          <Col md={4}>
            <Form.Label>
              Zip/Postal Code
            </Form.Label>
            <Form.Control
              name="zip"
              value={formData.zip}
              onChange={handleChange}
              isInvalid={!!errors.zip}
            />
            <Form.Control.Feedback type="invalid">
              {errors.zip}
            </Form.Control.Feedback>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button variant="outline-primary" onClick={handleReset} disabled={loading}>
          Reset Changes
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : "Save Changes"}
        </Button>
      </Modal.Footer>
    </Modal>

  );
}
